import React from 'react'

import Insumo from 'entity/Insumo'

import DefaultEntityCrud from 'components/form/DefaultEntityCrud'
import FormContent from 'components/form/FormContent'
import SelectInput from 'components/form/input/SelectInput'
import TextInput from 'components/form/input/TextInput'


function InsumoFormInter(props) {
    return (
        <FormContent sx={{ p: 2 }}>
            <TextInput
                sx={{ flex: 0.2 }}
                name="sequencialIndex"
                label="Código"
                disabled
            />
            <SelectInput
                sx={{ flex: 0.5 }}
                name="status"
                label="Status"
                options={["ATIVO", "INATIVO"]}
                required
            />

            <TextInput
                sx={{ flex: 1 }}
                name="nomeInsumo"
                label="(Inseticida/Formulado/Variedade)"
                required
            />

            <SelectInput
                sx={{ flex: 1 }}
                name="unidadeMedida"
                label="Unidade de Medida"
                options={[
                    "Unidade - UN",
                    "Quilos - KG",
                    "Litros - L",
                    "Tonelada - T",
                    "Hora - H",
                    "Dia - D"
                ]}
                required
            />
            <SelectInput
                sx={{ flex: 1 }}
                name="tipo"
                label="Tipo"
                options={[
                    "Adjuvante",
                    "Cultivar",
                    "Fertilizante",
                    "Fungicida",
                    "Herbicida",
                    "Inseticida",
                    "Mão-de-Obra",
                    "Outro"
                ]}
                required
            />
        </FormContent>
    )
}

export default function InsumoForm() {
    return (
        <DefaultEntityCrud
            title={"Cadastro de Insumo"}
            EntityClass={Insumo}
            routeForm={"_insumo"}
            backRoute="consulta-insumo"

            formActions={{ novoForm: false, salvarForm: true, sairForm: true }}
        >
            {(props) => <InsumoFormInter {...props} />}
        </DefaultEntityCrud>
    )
}
